import { Stack } from "@mui/material";
import useLocales from "src/hooks/useLocales";

import ConnectBtn from "./components/ConnectBtn";
import TextInputField from "./components/TextInputField";
import CredentialsCheckbox from "./CredentialsCheckbox";
import ErrorResult from "./ErrorResult";

// ----------------------------------------------------------------------

export const ConnectForm = () => {
	const { translate } = useLocales();
	return (
		<>
			<Stack sx={{ mt: 6 }} gap={2}>
				{<ErrorResult errorMessage={translate("connect_panel.incorrect_credentials")} />}
				<TextInputField label={translate("connect_panel.username")} type={"text"} />
				<TextInputField label={translate("connect_panel.password")} type='password' />
				<CredentialsCheckbox />
			</Stack>
			<ConnectBtn />
		</>
	);
};

export default ConnectForm;
